import React, { useContext } from 'react';
import { shape } from 'prop-types';
import {
  Button,
  Card,
  CardActions,
  CardBody,
  CardMedia,
  CardTitle,
  CardContent,
  Link
} from '@one-thd/sui-atomic-components';

import { extend } from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { getBundleItemData } from '../../utils/product-utils';
import { BundleImage } from '../BundleImage';
import { BundleMiniPrice } from '../BundleMiniPrice';
import { MultiParentItemFulfillment } from './MultiParentItemFulfillment';

const MultiParentItem = ({ bundle }) => {
  const experienceContext = useContext(ExperienceContext);
  const { channel } = experienceContext || {};
  // TODO replace with real products data when we implement price logic for multi-parent bundles
  const products = [
    {
      identifiers: {
        itemId: '316251424',
        productType: 'ABC',
        brandName: 'Milwaukee'
      },
      pricing: {
        original: null,
        mapAboveOriginalPrice: null,
        mapDetail: null,
        message: null,
        promotion: null,
        promotionalAdjustments: [],
        specialBuy: null,
        value: 199
      },
      itemId: '316251424'
    },
    {
      identifiers: {
        itemId: '319429226',
        productType: 'ABC',
        brandName: 'Milwaukee'
      },
      pricing: {
        original: 329,
        mapAboveOriginalPrice: null,
        mapDetail: null,
        message: null,
        promotion: {
          type: 'DISCOUNT',
          description: null,
          dollarOff: 50,
          percentageOff: 15
        },
        promotionalAdjustments: [],
        specialBuy: null,
        value: 279
      },
      itemId: '319429226'
    }
  ];
  if (!bundle || !products) return null;

  const {
    brand, image, label, url, buttonText
  } = getBundleItemData(bundle, products);

  return (
    <Card
      data-testid="multi-parent-item"
      CardContentProps={{
        className: 'sui-p-4 sui-flex sui-gap-4 sui-flex-col sm:sui-flex-row sm:sui-p-6 sm:sui-gap-6 sm:sui-items-center'
      }}
    >
      <CardContent className="sm:sui-basis-2/4">
        <a
          href={url}
        >
          <div className="sui-block sm:sui-hidden">
            <CardMedia
              component={BundleImage}
              aspectRatio="3:2"
              src={image}
              alt={label}
            />
          </div>
          <div className="sui-hidden sm:sui-block">
            <CardMedia
              component={BundleImage}
              aspectRatio="1:1"
              src={image}
              alt={label}
            />
          </div>
        </a>
      </CardContent>
      <CardContent className="sui-flex sui-gap-4 sui-flex-col sm:sui-basis-2/4">
        <div className="sui-flex sui-flex-col sui-gap-2">
          {
            brand && <Link variant="body-base" href={url} underline="none">{brand}</Link>
          }
          <CardTitle
            header={label}
            headerWeight="bold"
            component="a"
            href={url}
            headerVariant={channel === 'mobile' ? 'h5' : 'h3'}
          />
        </div>
        <CardBody disableGrow>
          {
            products?.length
            && (
              <BundleMiniPrice
                product={bundle}
                products={products}
                bundleId={bundle.itemId}
                hideUnitOfMeasure
                multiParent
              />
            )
          }
          <MultiParentItemFulfillment product={bundle} />
        </CardBody>
        <CardActions>
          <Button
            variant="secondary"
            href={url}
          >{buttonText}
          </Button>
        </CardActions>
      </CardContent>
    </Card>
  );
};

MultiParentItem.propTypes = {
  bundle: shape({}).isRequired
};

MultiParentItem.displayName = 'MultiParentItem';

MultiParentItem.dataModel = extend(
  BundleMiniPrice,
  MultiParentItemFulfillment
);

export { MultiParentItem };